import React from 'react';
import { renderToString } from 'react-dom/server';
import VehicleSpec from '../results/vehicleSpec';
import ResultList from '../results/resultList';
import ResultsNotes from '../results/resultsNotes';
import Disclaimer from '../disclaimer';
import store from '../../store';

const css = `
  * {box-sizing: border-box;}
  html, body {margin: 0; padding: 0;}
  h2 {font-size: 18px; margin: 0 0 20px;}
  h3 {font-size: 16px; margin: 0 0 20px;}
  table {font-size: inherit;}
  img {display: block; max-width: 100%;}

  #pdf-body {font: 12px sans-serif;}
  .banner {margin: 0 0 10px; width: 100%;}
  .page {min-height: 1030px;}
  .page--double-height {min-height: 2060px;}
  .page__title {font: normal 32px/1.2 sans-serif;}
  .section {padding: 20px 30px;}

  .spec { background-color: #FAFAFA; padding: 10px; }
  .spec p { display: inline-block; width: 50%; }
  .spec .button { display: inline-block; width: 25%; margin-top: 5px; padding: 12px 5px; line-height: 1; vertical-align: top; }
  .spec ul { margin: 0; padding: 0; list-style-type: none; }
  .spec ul li { display: inline-block; margin: 5px 0; width: 40%; }
  .spec ul li span { font-weight: bold; }
  .spec ul li:nth-child(even) { margin-right: 5px; }
  .spec ul li:first-child { width: 100%; }

  .list .other { padding: 2px; border-top: 1px solid #DDDDDD; }
  .list .other .title { margin-bottom: 12px; }
  .list .other p:nth-child(odd) { font-weight: bold; }
  .list .other p:not(.title) { display: inline-block; font-size: 0.75rem; }
  .list .other p:not(.title):nth-child(odd) { width: 30%; margin-right: 32px; }
  .list .engine { padding: 2px; }
  .list .engine__title p { margin-bottom: 10px; }
  .list .engine__title .title { font-weight: bold; }
  .list .engine__filters { min-width: 150px; }
  .list .engine__filters .input-name { margin-bottom: 5px; }
  .list .engine__filters .input-name + div { font-weight: bold; }
  .list .engine .product { border-top: 1px solid #DDDDDD; padding: 14px 0; }
  .list .engine img, .list .engine .details, .list .engine .button { display: inline-block; }
  .list .engine img { vertical-align: bottom; max-height: 75px; }
  .list .engine .details { margin-left: 20px; }
  .list .engine .button:first-of-type { margin-right: 20px; }
  .list .engine .details { width: 60%; color: #0D459A; }
  .list .engine .details p { margin-bottom: 12px; }
  .list .engine .details .button { width: 40%; }

  .results-notes { margin-top: 30px; font-size: 0.875rem; }
  .results-notes .title { font-weight: bold; border-bottom: 1px solid #DDDDDD; }

  .section--disclaimer { font-size: 11px; }
`.trim();

const Template = function(results) {
  return (
    <div id="pdf-body">
      <style dangerouslySetInnerHTML={{ __html: css }} />

      <div className="page page--double-height">
        <img
          className="banner"
          src={results.asset_path + 'images/pdf/pdf-banner-' + results.language + '.jpg'}
          alt="Banner"
        />
        <div className="section section--spec">
          <VehicleSpec equipment={results} />
        </div>
        <div className="section section--products">
          <ResultList equipment={results} showProductLinks={false} selectedEngineOption={store.getState().content.selected}/>
        </div>
      </div>
      <div className="page">
        <div className="section section--notes">
          {results.app_note ? <ResultsNotes equipment={results} expanded /> : ''}
        </div>
      </div>
      <div className="page">
        <div className="section section--disclaimer">
          <Disclaimer showFull />
        </div>
      </div>
    </div>
  );
};

export const GetPdfTemplate = function(props, asset_path, language) {
  props.asset_path = asset_path;
  props.language = language;
  return renderToString(<Template {...props} />);
};



// WEBPACK FOOTER //
// ./src/components/EmailForm/Attachment.js